if (typeof FN == 'undefined') FN = {};

FN.architectureAdaptiveButton = {
  instances: [],
  
  init: function() {
    // Handle split dropdown buttons
    const adaptiveButtons = document.querySelectorAll('[data-architecture-adaptive="true"]');
    
    adaptiveButtons.forEach(function(button) {
      const instance = new FN.architectureAdaptiveButton.Instance(button);
      FN.architectureAdaptiveButton.instances.push(instance);
    });
    
    // Handle single adaptive links
    const adaptiveLinks = document.querySelectorAll('[data-architecture-adaptive-link="true"]');
    
    adaptiveLinks.forEach(function(link) {
      const instance = new FN.architectureAdaptiveButton.LinkInstance(link);
      FN.architectureAdaptiveButton.instances.push(instance);
    });
  },
  
  Instance: function(container) {
    this.container = container;
    this.mainButton = container.querySelector('.button__main');
    this.buttonTextSpan = container.querySelector('.button-text');
    this.dropdownItem = container.querySelector('.download-dropdown__item');
    this.dropdownTextSpan = container.querySelector('.dropdown-item-text');
    
    // Store original values
    this.originalMainText = this.buttonTextSpan ? this.buttonTextSpan.getAttribute('data-default-text') : null;
    this.originalMainHref = this.mainButton ? this.mainButton.getAttribute('data-default-href') : null;
    this.originalDropdownText = this.dropdownTextSpan ? this.dropdownTextSpan.getAttribute('data-default-text') : null;
    this.armUrl = this.container.getAttribute('data-arm-url');
    
    this.init();
  },
  
  LinkInstance: function(link) {
    this.link = link;
    
    // Store original values
    this.originalHref = link.getAttribute('data-default-href');
    this.armHref = link.getAttribute('data-arm-href');
    
    this.init();
  }
};

FN.architectureAdaptiveButton.Instance.prototype = {
  init: function() {
    if (!this.mainButton || !this.buttonTextSpan || !this.dropdownItem || !this.dropdownTextSpan) {
      console.warn('Architecture adaptive button: Missing required elements');
      return;
    }
    
    this.detectAndUpdateButton();
  },
  
  detectAndUpdateButton: function() {
    const self = this;
    
    
    // Use architecture detector to determine user's architecture
    FN.architectureDetector.detect()
      .then(function(architecture) {
        self.updateButtonForArchitecture(architecture);
      })
      .catch(function(error) {
        console.warn('Architecture detection failed, using default (x86):', error);
        // Fallback to x86 as default - no changes needed since template defaults to x86
        self.updateButtonForArchitecture('x86');
      });
  },
  
  updateButtonForArchitecture: function(architecture) {
    
    if (architecture === 'arm') {
      this.configureForARM();
    } else {
      // Default to x86 for 'x86' or 'unknown'
      this.configureForx86();
    }
  },
  
  configureForARM: function() {
    // User is on ARM, so show ARM as main button and x86 in dropdown
    const armText = this.originalMainText.replace('(x64)', '(ARM)');
    const x86Text = this.originalDropdownText.replace('(ARM)', '(x64)');

    // Update main button
    this.buttonTextSpan.textContent = armText;
    // Set ARM download URL for main button
    this.mainButton.href = this.armUrl;
    
    // Update dropdown item
    this.dropdownTextSpan.textContent = x86Text;
    this.dropdownItem.href = this.originalMainHref; // x86 version goes to dropdown
    this.dropdownItem.setAttribute('data-track', 'x86');
    
    // Update aria label
    const dropdownTrigger = this.container.querySelector('.button__dropdown-trigger');
    if (dropdownTrigger) {
      dropdownTrigger.setAttribute('aria-label', 'More download options (x86 version available)');
    }
    
  },
  
  configureForx86: function() {
    // User is on x86, keep default configuration (x86 main, ARM in dropdown)
    // This is already the default state from the template, but we'll be explicit
    
    // Ensure main button shows x86
    this.buttonTextSpan.textContent = this.originalMainText;
    this.mainButton.href = this.originalMainHref;
    
    // Ensure dropdown shows ARM
    this.dropdownTextSpan.textContent = this.originalDropdownText;
    this.dropdownItem.href = this.armUrl; // ARM download URL
    this.dropdownItem.setAttribute('data-track', 'arm');
    
    // Update aria label
    const dropdownTrigger = this.container.querySelector('.button__dropdown-trigger');
    if (dropdownTrigger) {
      dropdownTrigger.setAttribute('aria-label', 'More download options (ARM version available)');
    }
    
  }
};

FN.architectureAdaptiveButton.LinkInstance.prototype = {
  init: function() {
    if (!this.originalHref || !this.armHref) {
      console.warn('Architecture adaptive link: Missing required href attributes');
      return;
    }
    
    this.detectAndUpdateLink();
  },
  
  detectAndUpdateLink: function() {
    if (!FN.architectureDetector || typeof FN.architectureDetector.detect !== 'function') {
      console.warn('Architecture detector not available, using default href');
      return;
    }
    
    FN.architectureDetector.detect()
      .then(function(architecture) {
        if (architecture === 'arm') {
          this.configureForARM();
        } else {
          this.configureForx86();
        }
      }.bind(this))
      .catch(function(error) {
        console.warn('Failed to detect architecture for adaptive link:', error);
      });
  },
  
  configureForARM: function() {
    // User is on ARM, update href to ARM version
    this.link.href = this.armHref;
  },
  
  configureForx86: function() {
    // User is on x86, use default href
    this.link.href = this.originalHref;
  }
};

// Initialize on DOM ready, but after architecture detector
$(document).ready(function() {
  // Small delay to ensure architecture detector is available
  setTimeout(function() {
    if (typeof FN.architectureDetector !== 'undefined') {
      FN.architectureAdaptiveButton.init();
    } else {
      console.warn('Architecture detector not available, adaptive buttons will use defaults');
    }
  }, 100);
});